export const USERS_VIEW_REQUIRED_PERMISSION = 'user-admin.users.read';
export const PERMISSIONS_VIEW_REQUIRED_PERMISSION = 'user-admin.permissions.read';
export const GROUPS_VIEW_REQUIRED_PERMISSION = 'user-admin.groups.read';

export const USERS_WRITE_REQUIRED_PERMISSION = 'user-admin.users.write';
export const PERMISSIONS_WRITE_REQUIRED_PERMISSION = 'user-admin.permissions.write';
export const GROUPS_WRITE_REQUIRED_PERMISSION = 'user-admin.groups.write';
